import React from "react";
import "./CompanyOverview.css"; // Reusing same card layout

const TermsAndConditions = () => {
    return (
        <div className="company-wrapper">
            <div className="company-card">
                <h1 className="main-heading">📄 Terms and Conditions</h1>
                <p><strong>Last Updated:</strong> 27 June 2025</p>

                <p>
                    Welcome to Global Link Corporation’s website, accessible at{' '}
                    <a href="https://www.globallinkcorporation.com" target="_blank" rel="noopener noreferrer">
                        www.globallinkcorporation.com
                    </a>.
                    By accessing or using our website, you agree to comply with and be bound by the following Terms and Conditions. Please read them carefully.
                    If you do not agree with any part of these terms, you must not use our website.
                </p>

                <h2>1. Company Information</h2>
                <p>
                    <strong>Global Link Corporation</strong><br />
                    Platinum Plaza, F-5, Near New Lions School, Ankleshwar GIDC, Ankleshwar, Gujarat – 393001<br />
                    Email: <a href="mailto:Info@globallinkcorporation.com">Info@globallinkcorporation.com</a>
                </p>

                <h2>2. Use of the Website</h2>
                <p>
                    You agree to use this website only for lawful purposes and in a way that does not infringe the
                    rights of or restrict or inhibit the use of the site by any third party. You are prohibited from:
                </p>
                <ul>
                    <li>Copying, reproducing, or redistributing website content without permission</li>
                    <li>Attempting to interfere with the website’s functionality or security</li>
                    <li>Using the website to transmit any unlawful, harmful, or objectionable material</li>
                </ul>

                <h2>3. Intellectual Property Rights</h2>
                <p>
                    All content, branding, graphics, logos, and materials on this website are the intellectual property
                    of Global Link Corporation, unless otherwise stated. You may not reproduce, modify, or
                    distribute any part of this site without express written consent.
                </p>

                <h2>4. Products and Services</h2>
                <p>
                    All product descriptions, prices, and availability are subject to change without notice. While we
                    strive for accuracy, we do not guarantee that product information or pricing on the site is always
                    up to date, complete, or accurate.
                </p>
                <p>
                    We reserve the right to refuse service or cancel orders at our discretion, including orders that
                    appear to be fraudulent or violate our policies.
                </p>

                <h2>5. Limitation of Liability</h2>
                <p>
                    Global Link Corporation shall not be liable for any direct, indirect, incidental, consequential, or
                    punitive damages arising from your use of (or inability to use) the website, even if we have been
                    advised of the possibility of such damages.
                </p>
                <p>
                    We do not guarantee that the website will be available at all times or that it will be free from
                    errors, viruses, or other harmful components.
                </p>

                <h2>6. Third-Party Links</h2>
                <p>
                    Our website may contain links to external websites that are not operated by us. We are not
                    responsible for the content, terms, or privacy practices of any third-party sites.
                </p>

                <h2>7. Privacy Policy</h2>
                <p>
                    Your use of this website is also governed by our{' '}
                    <a href="/privacy-policy">Privacy Policy</a>, which explains how we collect, use, and protect your data.
                </p>

                <h2>8. Governing Law</h2>
                <p>
                    These Terms and Conditions are governed by and construed in accordance with the laws of
                    India. Any disputes arising from the use of this website shall be subject to the exclusive
                    jurisdiction of the courts in Gujarat, India.
                </p>

                <h2>9. Changes to These Terms</h2>
                <p>
                    We may update or modify these Terms and Conditions at any time without prior notice. Changes
                    will be effective immediately upon posting to the website. Your continued use of the website
                    constitutes your acceptance of any revised terms.
                </p>

                <h2>10. Contact Us</h2>
                <p>
                    If you have any questions about these Terms and Conditions, please contact us at:<br />
                    <a href="mailto:Info@globallinkcorporation.com">Info@globallinkcorporation.com</a><br />
                    Platinum Plaza, F-5, Near New Lions School, Ankleshwar GIDC, Ankleshwar, Gujarat – 393001
                </p>
            </div>
        </div>
    );
};

export default TermsAndConditions;
